import React, { useEffect, useState, useRef } from "react";
import {
  useSearchParams,
  useNavigate,
  Link,
  useLocation,
} from "react-router-dom";
import type { SVGProps } from "react";
import LeadGenCtaBtn from "../../features/lead-generation/LeadGenCtaBtn";
import { BaseURL, BaseURLAuth } from "../../services/api";
import config from "../../util/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { EpRight } from "../../components/study-abroad-landing/Banner/Banner";
import useQueryParamPagination from "../../components/filter/customHooks/useQueryParamPagination";
import Banner from "../exam-intermediate/components/Banner";

export function StashSearchSolid(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.44 2.75a7.69 7.69 0 1 0 4.615 13.842c.058.17.154.329.29.464l3.84 3.84a1.21 1.21 0 0 0 1.71-1.712l-3.84-3.84a1.2 1.2 0 0 0-.463-.289A7.69 7.69 0 0 0 10.44 2.75m-5.75 7.69a5.75 5.75 0 1 1 11.5 0a5.75 5.75 0 0 1-11.5 0"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function MaterialSymbolsLightClose(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z"
      ></path>
    </svg>
  );
}
export function IconParkOutlineDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 48 48"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="M36 18L24 30L12 18"
      ></path>
    </svg>
  );
}
interface Exam {
  examId: number;
  title: string;
  name: string;
  level: string;
  mode: string;
  frequency: string;
  examIcon?: string;
  application: {
    examDate: string;
    opendDates: string;
    fees?: number;
  };
  isDataAvailable: boolean;
}

interface FilterOption {
  name: string;
  count?: number;
  key: string;
}

interface FilterCategory {
  categoryKey: string;
  categoryName?: string;
  options: FilterOption[];
}

interface Stream {
  name: string;
  title: string;
}

interface DataResponse {
  exams: Exam[];
  streams: Stream[];
  filters: FilterCategory[];
  totalexamCount: number;
}

const ExamListing: React.FC = () => {
  const [data, setData] = useState<DataResponse | null>(null);
  const [selectedStream, setSelectedStream] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const [sortKey, setSortKey] = useState("popular");
  const [selectedFilters, setSelectedFilters] = useState<
    Record<string, string[]>
  >({});
  const [totalCount, setTotalCount] = useState<number | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [filtersLoadedFromURL, setFiltersLoadedFromURL] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [wishlistData, setWishlistData] = useState<{ examId: number }[]>([]);
  const { pathname } = useLocation();
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({
    degree: true,
  });
  const [searchInputs, setSearchInputs] = useState<Record<string, string>>({});
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalExamCount, setTotalExamCount] = useState();

  const PAGE_SIZE = 10;
  const { totalPages, updateTotalCount, handleResetPagination } =
    useQueryParamPagination(PAGE_SIZE);

  useEffect(() => {
    updateTotalCount(totalExamCount || 0);
  }, [totalExamCount]);

  const handlePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const fetchWishlistData = () => {
    const userId = JSON.parse(localStorage.getItem("user") ?? "{}")?.userId;
    const accessToken = localStorage.getItem("accessToken");
    if (userId) {
      BaseURL.get(`/api/wishlist/category/${userId}?category=exam`, {
        headers: {
          Authorization: accessToken ? `${accessToken}` : "",
        },
      })
        .then((response) => {
          setWishlistData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching wishlist data:", error);
        });
    }
  };
  const searchableKeys = ["degree", "examinationType", "medium"];
  useEffect(() => {
    fetchWishlistData();
  }, []);
  const handleWishList = (examId: number) => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/secure/login", { state: { sourcePagePath: pathname } });
    } else {
      const toggleWishlist = async () => {
        try {
          if (JSON.parse(localStorage.getItem("user") ?? "{}")?.userId) {
            const apiUrl =
              wishlistData.find((exam) => exam.examId === examId) !== undefined
                ? config.apiUrl + "/api/wishlist/remove"
                : config.apiUrl + "/api/wishlist/add";

            const response = await BaseURLAuth.post(
              apiUrl,
              {
                categoryName: "exam",
                categoryId: examId,
                userId: JSON.parse(user)?.userId,
              },
              {
                headers: {
                  Authorization: localStorage.getItem("accessToken"),
                  "X-Auth-Token":
                    "e711724f44c71abf0c2794572472ed6edcea55a351f6428fe67060a692aa9316",
                },
              }
            );
            if (response.data) {
              fetchWishlistData();
            } else {
              console.error("Error toggling wishlist:", response.statusText);
            }
          }
        } catch (error) {
          console.error("Error toggling wishlist:", error);
        }
      };
      toggleWishlist();
    }
  };

  const formatHeader = (text: string) =>
    text.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialFilters: Record<string, string[]> = {};

    params.forEach((value, key) => {
      if (key === "stream") {
        setSelectedStream(value);
      } else if (key === "search") {
        setSearchTerm(value);
      } else if (key === "sortBy") {
        setSortKey(value);
      } else {
        initialFilters[key] = value.split(",");
      }
    });

    setSelectedFilters(initialFilters);
    setFiltersLoadedFromURL(true);
  }, []);
  useEffect(() => {
    if (!filtersLoadedFromURL) return;

    const fetchData = async () => {
      const payload: Record<string, any> = {
        sortBy: sortKey,
        stream: selectedStream,
        offset: currentPage - 1,
        fetchCount: PAGE_SIZE,
        search: submittedSearch,
      };

      Object.entries(selectedFilters).forEach(([key, values]) => {
        if (values.length) {
          payload[key] = values.length === 1 ? values[0] : values;
        }
      });
      console.log("Final Payload:", payload);

      try {
        const res = await fetch(`${config.apiUrl}/api/exam/intermediate`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const json = await res.json();
        const innerData = json?.data?.data;
        const filters = json?.data?.filters;
        const streams = json?.data?.streams;

        if (innerData) {
          setData({
            exams: innerData.exams || [],
            totalexamCount: innerData.totalexamCount || 0,
            streams: streams ?? [],
            filters: filters ?? [],
          });
          setTotalCount(innerData.totalexamCount || 0);
        }
      } catch (err) {
        console.error("Fetch error", err);
      }
    };

    fetchData();
  }, [selectedFilters, selectedStream, submittedSearch, sortKey, currentPage]);

  const handleFilterChange = (categoryKey: string, key: string) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [categoryKey]: [key],
    }));
  };
  useEffect(() => {
    const params = new URLSearchParams();

    if (selectedStream) {
      params.set("stream", selectedStream);
    }

    if (sortKey !== "popular") {
      params.set("sortBy", sortKey);
    }

    Object.entries(selectedFilters).forEach(([key, values]) => {
      if (values.length) {
        params.set(key, values.join(","));
      }
    });

    setSearchParams(params);
  }, [selectedFilters, selectedStream, sortKey]);

  const scroll = (direction: "left" | "right") => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const scrollAmount = 200;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const updateScrollButtons = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    setCanScrollLeft(container.scrollLeft > 0);
    setCanScrollRight(
      container.scrollLeft + container.clientWidth < container.scrollWidth
    );
  };
  useEffect(() => {
    updateScrollButtons();
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);

    return () => {
      container.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  return (
    <>
      <Banner />
      <div className="flex flex-col p-4 gap-4 bg-grey-2 text-black font-inter md:gap-12">
        <div className="container mx-auto">
          <div className="flex flex-col gap-6 md:gap-10">
            <div className="w-full flex items-center justify-center gap-2">
              {(data?.streams?.length ?? 0) > 0 && (
                <button
                  className={`p-3 bg-white border border-solid border-black rounded-full text-center transition-opacity ${
                    canScrollLeft
                      ? "opacity-100"
                      : "opacity-40 pointer-events-none"
                  }`}
                  onClick={() => scroll("left")}
                >
                  <EpRight className="rotate-180" />
                </button>
              )}

              <div
                ref={scrollContainerRef}
                className="flex overflow-x-auto whitespace-nowrap scrollbar-hide"
              >
                {data?.streams?.map((s) => (
                  <button
                    key={s.name}
                    onClick={() => setSelectedStream(s.name)}
                    className={`px-6 py-2 text-base rounded-md mx-1 whitespace-nowrap ${
                      selectedStream === s.name
                        ? "bg-green text-white"
                        : "bg-white text-gray-600"
                    }`}
                  >
                    {s.title}
                  </button>
                ))}
              </div>
              {(data?.streams?.length ?? 0) > 0 && (
                <button
                  className={`p-3 bg-white border border-solid border-black rounded-full text-center transition-opacity ${
                    canScrollRight
                      ? "opacity-100"
                      : "opacity-40 pointer-events-none"
                  }`}
                  onClick={() => scroll("right")}
                >
                  <EpRight />
                </button>
              )}
            </div>

            <div className="flex flex-col lg:flex-row gap-4">
              <aside className="w-full lg:w-1/4 bg-[#061958] p-4 rounded-lg text-white">
                <div className="flex justify-between items-center border-b border-white pb-2 mb-4">
                  <h3 className="text-lg font-bold">Filter by</h3>

                  {(selectedStream ||
                    Object.keys(selectedFilters).length > 0) && (
                    <button
                      onClick={() => {
                        setSelectedStream("");
                        setSelectedFilters({});
                      }}
                      className="text-sm text-white underline"
                    >
                      Clear All
                    </button>
                  )}
                </div>

                {data?.filters?.map((cat) => {
                  const categoryKey = cat.categoryKey;

                  const isSearchable = searchableKeys.includes(categoryKey);
                  const isOpen = openSections[categoryKey] ?? false;
                  const searchText = searchInputs[categoryKey] ?? "";

                  const filteredOptions = isSearchable
                    ? cat.options.filter((opt) =>
                        opt.name
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                      )
                    : cat.options;

                  return (
                    <div
                      key={categoryKey}
                      className="border-b border-gray-200 py-3"
                    >
                      <button
                        className="flex justify-between w-full items-center text-left font-bold text-white"
                        onClick={() =>
                          setOpenSections((prev) => ({
                            ...prev,
                            [categoryKey]: !prev[categoryKey],
                          }))
                        }
                      >
                        <span className="flex justify-between items-center w-full font-medium text-base text-white uppercase">
                          {formatHeader(cat.categoryName || categoryKey)}
                        </span>
                        <span className="text-white text-xl">
                          {isOpen ? (
                            <IconParkOutlineDown className="rotate-180" />
                          ) : (
                            <IconParkOutlineDown />
                          )}
                        </span>
                      </button>

                      {isOpen && (
                        <>
                          <div className="pt-4 flex flex-col gap-2">
                            {isSearchable && (
                              <input
                                type="text"
                                placeholder={`Search by ${formatHeader(
                                  cat.categoryName || categoryKey
                                )}`}
                                value={searchText}
                                onChange={(e) =>
                                  setSearchInputs((prev) => ({
                                    ...prev,
                                    [categoryKey]: e.target.value,
                                  }))
                                }
                                className="w-full mb-2 px-3 py-2 rounded bg-white text-black placeholder-gray-500 text-sm"
                              />
                            )}
                            <div className="filter-section max-h-48 overflow-y-auto">
                              <ul className="space-y-2 flex flex-col gap-1">
                                {filteredOptions.map((opt) => (
                                  <li key={opt.key}>
                                    <label className="flex items-start gap-2 cursor-pointer text-sm text-wrap">
                                      <span className="relative w-5 h-5 block">
                                        <input
                                          type="checkbox"
                                          className="peer appearance-none w-5 h-5 max-w-5 rounded-sm border border-white bg-transparent checked:bg-white transition-all duration-200"
                                          checked={
                                            selectedFilters[
                                              categoryKey
                                            ]?.[0] === opt.key
                                          }
                                          onChange={() =>
                                            handleFilterChange(
                                              categoryKey,
                                              opt.key
                                            )
                                          }
                                        />
                                        <svg
                                          width="14"
                                          height="12"
                                          viewBox="0 0 14 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 peer-checked:opacity-100"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12.7554 0.971074C13.1039 1.29115 13.1342 1.8412 12.8231 2.19968L4.76617 11.4812C4.60566 11.6661 4.37612 11.7718 4.13513 11.7718C3.89414 11.7718 3.66459 11.6661 3.50409 11.4812L0.281339 7.76856C-0.0298314 7.41006 0.000443473 6.86002 0.348961 6.54004C0.697467 6.21994 1.23226 6.25103 1.54343 6.60953L4.13513 9.59516L11.561 1.04063C11.8721 0.682153 12.4069 0.651013 12.7554 0.971074Z"
                                            fill="#00B489"
                                          />
                                        </svg>
                                      </span>
                                      <span className="text-base text-white">
                                        {opt.name.trim()} ({opt.count || 0})
                                      </span>
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </aside>

              <main className="w-full lg:w-3/4 flex flex-col gap-6 relative">
                <div className="flex flex-col gap-4 items-start w-full">
                  <div className="flex flex-col sm:flex-row justify-between w-full">
                    <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                      <label className="flex items-center relative w-full md:w-[400px] justify-end">
                        <input
                          type="text"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder="Search exams..."
                          className="search-input rounded-md px-5 py-3 w-full"
                        />
                        <button
                          onClick={() => {
                            setSubmittedSearch(searchTerm);
                          }}
                          className="bg-transparent border-none text-white px-4 py-2 rounded text-sm absolute right-0"
                        >
                          <StashSearchSolid className="text-grey" />
                        </button>
                      </label>
                    </div>
                    <div className="flex flex-col">
                      <select
                        className="bg-white border border-gray-300 rounded-md p-2 flex justify-between items-center"
                        value={sortKey}
                        onChange={(e) => setSortKey(e.target.value)}
                      >
                        {data?.filters
                          ?.find((f) => f.categoryKey === "sortBy")
                          ?.options.map((opt) => (
                            <option key={opt.key} value={opt.key}>
                              {opt.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="flex flex-wrap gap-2">
                      <p className="text-base md:text-lg text-grey shrink-0 min-w-48">
                        Showing {data?.totalexamCount} Exams
                      </p>
                      <div className="flex gap-2 flex-wrap items-center">
                        {selectedStream && (
                          <span className="flex items-center border rounded-full px-3 py-1 text-sm bg-white shadow-sm">
                            {data?.streams.find(
                              (s) => s.name === selectedStream
                            )?.title || selectedStream}
                            <button
                              onClick={() => {
                                setSelectedStream("");
                              }}
                              className="ml-1"
                            >
                              <MaterialSymbolsLightClose />
                            </button>
                          </span>
                        )}

                        {Object.entries(selectedFilters).flatMap(
                          ([key, values]) =>
                            values.map((v) => {
                              const category = data?.filters?.find(
                                (f) => f.categoryKey === key
                              );
                              const optionLabel =
                                category?.options.find((opt) => opt.key === v)
                                  ?.name || v;

                              return (
                                <span
                                  key={`${key}-${v}`}
                                  className="flex items-center border rounded-full px-3 py-1 text-sm bg-white shadow-sm"
                                >
                                  {optionLabel}
                                  <button
                                    onClick={() => {
                                      setSelectedFilters((prev) => {
                                        const updated = { ...prev };
                                        updated[key] = updated[key].filter(
                                          (val) => val !== v
                                        );
                                        if (updated[key].length === 0)
                                          delete updated[key];
                                        return updated;
                                      });
                                    }}
                                    className="ml-1"
                                  >
                                    <MaterialSymbolsLightClose />
                                  </button>
                                </span>
                              );
                            })
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="w-full flex flex-col gap-6">
                    {data?.exams.map((exam) => (
                      <div
                        key={exam.examId}
                        className="relative flex flex-row md:gap-10 md:w-full rounded-md bg-[#fff]  p-[21px] max-md:flex-col justify-between w-full"
                        style={{
                          boxShadow: "0px 2px 10px 2px rgba(0, 0, 0, 0.06)",
                        }}
                      >
                        <div className="flex flex-col lg:flex-row justify-between w-full gap-4 md:gap-8 items-center">
                          <div className="flex flex-col gap-2 w-full">
                            <div className="flex flex-row gap-6 ">
                              <div
                                className="md:p-2 rounded-md max-md:h-[49px] max-md:w-[49px] max-md:p-1"
                                style={{
                                  border: "1px solid #E5E5E5",
                                }}
                              >
                                <img
                                  src="/images/exam-jee-icon.jpg"
                                  alt="exam-icon"
                                  className="rounded max-md:w-[40px] max-md:h-[40px]"
                                />
                              </div>
                              <div className="flex flex-col gap-[18px] py-1">
                                <div className="flex">
                                  <h3
                                    className={`text-[#181A27] font-bold text-lg`}
                                  >
                                    <Link to={`/exam-details/${exam.name}`}>
                                      {exam.title}
                                    </Link>
                                    <span className="text-[#00B489] ml-1 text-base font-semibold md:hidden">
                                      • {exam.mode}
                                    </span>
                                  </h3>
                                  <span className="text-[#00B489] ml-1 text-base font-semibold max-md:hidden">
                                    • {exam.mode}
                                  </span>

                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleWishList(exam.examId);
                                    }}
                                    className={`absolute right-[50px] min-max-xss:right-5 min-max-xs:right-7 rounded transition-colors duration-300 ${
                                      isClicked ? "" : ""
                                    }`}
                                  >
                                    <FontAwesomeIcon
                                      icon={faHeart}
                                      color={
                                        wishlistData?.some(
                                          (item) => item.examId === exam.examId
                                        )
                                          ? "#EC1A3B" // red heart
                                          : "#FFF" // white heart
                                      }
                                      stroke="#EC1A3B"
                                      size="lg"
                                      strokeWidth={40}
                                    />
                                  </button>
                                </div>
                                <div className="flex flex-wrap gap-2 max-md:hidden">
                                  <div className="flex items-center gap-1">
                                    <img
                                      src="/images/exam-time-icon.jpg"
                                      alt=""
                                    />
                                    <span className="text-[#181A27] font-normal text-sm px-1">
                                      {exam.mode}
                                    </span>
                                  </div>
                                  <span className="text-[#ccc] w-[2px] pr-2">
                                    |
                                  </span>
                                  <div className="flex items-center gap-1">
                                    <img
                                      src="/images/exam-openbook-icon.jpg"
                                      alt=""
                                    />
                                    <span className="text-[#181A27] font-normal text-sm px-1">
                                      {exam.level}
                                    </span>
                                  </div>
                                  <span className="text-[#ccc] w-[2px] pr-1">
                                    |
                                  </span>
                                  <div className="flex items-center gap-1">
                                    <img
                                      src="/images/exam-timeremove-icon.jpg"
                                      alt=""
                                    />
                                    <span className="text-[#181A27] font-normal text-sm px-1">
                                      {exam.frequency}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-wrap gap-1 md:hidden text-[13px]">
                              <div className="flex items-center ">
                                <img src="/images/exam-time-icon.jpg" alt="" />
                                <span className="text-[#181A27] font-normal  px-1">
                                  {exam.mode}
                                </span>
                              </div>
                              <span className="text-[#ccc] w-[2px] pr-2">
                                |
                              </span>
                              <div className="flex items-center ">
                                <img
                                  src="/images/exam-openbook-icon.jpg"
                                  alt=""
                                />
                                <span className="text-[#181A27] font-normal  px-1">
                                  {exam.level}
                                </span>
                              </div>
                              <span className="text-[#ccc] w-[2px] pr-1">
                                |
                              </span>
                              <div className="flex items-center ">
                                <img
                                  src="/images/exam-timeremove-icon.jpg"
                                  alt=""
                                />
                                <span className="text-[#181A27] font-normal  px-1">
                                  {exam.frequency}
                                </span>
                              </div>
                            </div>

                            <div className="flex  py-[17px]  min-max-xss:w-[300px] min-max-xs:w-[350px] ">
                              <table className=" bg-white border border-[#D1D1D1]">
                                <thead>
                                  <tr className="border-b border-[#D1D1D1]">
                                    <td className="py-2 border-r border-[#D1D1D1] px-4  text-left text-base font-medium text-[#173CBA] ">
                                      Application Open
                                    </td>
                                    <td className="py-2 px-4 text-left text-sm font-medium text-[#000]">
                                      {exam.application.opendDates} (Application
                                      Cost:
                                      {exam.application.fees}/-)
                                    </td>
                                  </tr>
                                  <tr className="border-b border-[#D1D1D1]">
                                    <td className="py-2 border-r border-[#D1D1D1] px-4 text-left text-base font-medium text-[#173CBA] ">
                                      Exam Dates
                                    </td>
                                    <td className="py-2 px-4 text-left text-sm font-medium text-[#000]">
                                      {exam?.application?.examDate}
                                    </td>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                            {/* <div className="flex flex-col gap-3 md:hidden mb-3 w-[130px]">
                    <LeadGenCtaBtn
                      pageName="exam-landing"
                      ctaName={exam.title}
                      className="button-styles green-bg items-center rounded-none hover:bg-blue whitespace-nowrap"
                    >
                      Apply Now{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="12"
                        viewBox="0 0 15 12"
                        fill="none"
                      >
                        <path
                          d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
                          fill="white"
                        />
                      </svg>
                    </LeadGenCtaBtn>
                  </div> */}

                            <div
                              className="flex flex-wrap text-[#69678B] text-sm font-normal capitalize list-none"
                              style={{
                                padding: "15px 32.75px 1px 0px",
                                borderTop: "1px solid #CCC",
                              }}
                            >
                              <Link
                                to={`/exam-details/${exam.name}#overview`}
                                className="md:px-2 max-md:px-1 max-md:py-1"
                              >
                                Overview
                              </Link>
                              <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                                |
                              </span>
                              <Link
                                to={`/exam-details/${exam.name}#eligibility-criteria`}
                                className="md:px-2 max-md:px-1 max-md:py-1"
                              >
                                Eligibility
                              </Link>
                              <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                                |
                              </span>
                              <Link
                                to={`/exam-details/${exam.name}#application`}
                                className="md:px-2 max-md:px-1 max-md:py-1"
                              >
                                Application Process
                              </Link>
                              <span className="text-[#ccc] font-normal text-sm px-1 max-md:hidden max-md:py-1">
                                |
                              </span>
                              <Link
                                to={`/exam-details/${exam.name}#exam-pattern`}
                                className="md:px-2 max-md:px-1 max-md:py-1"
                              >
                                Exam Pattern
                              </Link>
                              <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                                |
                              </span>
                              <Link
                                to={`/exam-details/${exam.name}#result-n-cut-off`}
                                className="md:px-2 max-md:px-1 max-md:py-1"
                              >
                                Results
                              </Link>
                              <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                                |
                              </span>
                            </div>
                          </div>

                          <div className="flex flex-col gap-3">
                            <LeadGenCtaBtn
                              pageName="exam-results"
                              ctaName={exam.title}
                              className="button-styles green-bg items-center rounded-none hover:bg-blue whitespace-nowrap !py-3 !px-6"
                            >
                              Apply Now{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="12"
                                viewBox="0 0 15 12"
                                fill="none"
                              >
                                <path
                                  d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
                                  fill="white"
                                />
                              </svg>
                            </LeadGenCtaBtn>
                            <button
                              onClick={handlePopup}
                              className="hidden rounded-md bg-[#fff] items-center text-[#173CBA] md:px-[15px] md:py-[6.6px] max-md:px-[8px] max-md:py-[3px]"
                              style={{
                                border: "1.128px solid #173CBA",
                              }}
                            >
                              Get Alerts
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="23"
                                viewBox="0 0 23 23"
                                fill="none"
                                className="ml-[6px]"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M8.88903 4.81669V5.31144C6.35976 6.34862 4.59269 9.7553 4.65681 12.7078L4.6568 14.3476C3.36201 16.0121 3.43819 18.494 6.66852 18.494H8.88903C8.88903 19.1741 9.15409 19.8264 9.62592 20.3074C10.0977 20.7883 10.7376 21.0585 11.4048 21.0585C12.0721 21.0585 12.7119 20.7883 13.1837 20.3074C13.6555 19.8264 13.9205 19.1741 13.9205 18.494H16.1472C19.3713 18.494 19.4181 16.0069 18.1235 14.3424L18.1595 12.71C18.2246 9.75414 16.4541 6.34439 13.9205 5.30868V4.81669C13.9205 4.13654 13.6555 3.48425 13.1837 3.00332C12.7119 2.52239 12.0721 2.2522 11.4048 2.2522C10.7376 2.2522 10.0977 2.52239 9.62592 3.00332C9.15409 3.48425 8.88903 4.13654 8.88903 4.81669ZM12.2434 4.81669C12.2434 4.81669 12.2428 4.85136 12.2418 4.86859C11.9687 4.83433 11.6905 4.81669 11.4082 4.81669C11.1236 4.81669 10.8431 4.83462 10.5678 4.86942C10.5667 4.85192 10.5662 4.83433 10.5662 4.81669C10.5662 4.58998 10.6545 4.37255 10.8118 4.21224C10.9691 4.05192 11.1824 3.96186 11.4048 3.96186C11.6272 3.96186 11.8405 4.05192 11.9978 4.21224C12.155 4.37255 12.2434 4.58998 12.2434 4.81669ZM10.5662 18.494C10.5662 18.7207 10.6545 18.9382 10.8118 19.0985C10.9691 19.2587 11.1824 19.3488 11.4048 19.3488C11.6272 19.3488 11.8405 19.2587 11.9978 19.0985C12.155 18.9382 12.2434 18.7207 12.2434 18.494H10.5662ZM16.1472 16.7843C16.8636 16.7843 17.2501 15.9277 16.7839 15.3732C16.5573 15.1038 16.4366 14.761 16.4444 14.4092L16.4827 12.6716C16.5467 9.76923 14.2561 6.52635 11.4082 6.52635C8.56087 6.52635 6.27056 9.76815 6.33358 12.6699L6.37136 14.4094C6.379 14.7612 6.2583 15.1039 6.03181 15.3732C5.56555 15.9277 5.95206 16.7843 6.66852 16.7843H16.1472ZM16.1137 3.38247C16.4095 2.95568 16.9955 2.84952 17.4223 3.14538C18.5015 3.89348 19.7957 5.68762 20.5024 7.81191C20.6663 8.30467 20.3997 8.83703 19.907 9.00095C19.4141 9.16488 18.8818 8.8983 18.7178 8.40553C18.0971 6.53955 16.9997 5.14074 16.3509 4.69098C15.9241 4.39512 15.8179 3.80928 16.1137 3.38247ZM5.25345 3.14538C5.68026 2.84952 6.2661 2.95568 6.56195 3.38247C6.85781 3.80928 6.75166 4.39512 6.32486 4.69098C5.67602 5.14074 4.57855 6.53955 3.95781 8.40553C3.79389 8.8983 3.26153 9.16488 2.76876 9.00095C2.27598 8.83703 2.0094 8.30467 2.17333 7.81191C2.87999 5.68762 4.17425 3.89348 5.25345 3.14538Z"
                                  fill="#173CBA"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex justify-center items-center gap-2 mt-6 bg-white p-2 rounded-full w-fit mx-auto text-sm font-medium text-gray-700">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage <= 1}
                    className={`px-4 py-2 rounded-l-full flex items-center gap-1 ${
                      currentPage <= 1
                        ? "text-gray-400 cursor-not-allowed"
                        : "hover:underline bg-white"
                    }`}
                  >
                    <IconParkOutlineDown className="rotate-90" /> Prev
                  </button>

                  <span className="px-4 py-2 border-x border-gray-300">
                    {currentPage} of {Math.ceil((totalCount ?? 0) / PAGE_SIZE)}
                  </span>

                  <button
                    onClick={() =>
                      setCurrentPage((prev) =>
                        prev < Math.ceil((totalCount ?? 0) / PAGE_SIZE)
                          ? prev + 1
                          : prev
                      )
                    }
                    disabled={
                      currentPage >= Math.ceil((totalCount ?? 0) / PAGE_SIZE)
                    }
                    className={`px-4 py-2 rounded-r-full flex items-center gap-1 ${
                      currentPage >= Math.ceil((totalCount ?? 0) / PAGE_SIZE)
                        ? "text-gray-400 cursor-not-allowed"
                        : "hover:underline bg-white"
                    }`}
                  >
                    Next <IconParkOutlineDown className="-rotate-90" />
                  </button>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamListing;
